import $graph from "./graph";
import $register from "./register";
import $login from "./login";
import $findPassword from "./findPassword";

// 以数组的结构保存组件，便于遍历
const components = [$register, $login, $findPassword, $graph];
// 定义 install 方法
const install: any = function (Vue: any) {
//   if (install.installed) return;
//   install.installed = true;
  // 遍历并注册全局组件
  components.map((component) => {
    Vue.component(component.name, component);
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

// export default install
export default {
  install,
  ...components
};
// export const graph =  $graph;
// export const login =  $login;
// export const register =  $register;
// export const findPassword =  $findPassword;